var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6906 12.0435L18.3445 6.75H17.2418L13.199 11.3453L9.97239 6.75H6.25L11.1304 13.6995L6.25 19.25H7.35268L11.6194 14.3961L15.0276 19.25H18.75L13.6906 12.0435ZM12.1798 13.7605L11.6846 13.068L7.75033 7.56342H9.44428L12.6203 12.0075L13.1134 12.6999L17.2413 18.4762H15.5474L12.1798 13.7605Z",
    fill: "#0F1419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3486f3adf89bc20d811d3945a12efdea.svg";
export { ForwardRef as ReactComponent };